import { useMutation } from '@tanstack/react-query'
import isArray from 'lodash/isArray'
import isNil from 'lodash/isNil'
import { useRouter } from 'next/router'
import { signIn } from 'next-auth/react'
import { useEffect, useState } from 'react'
import { LoginPage, LoginSteps } from '@omnea-app/fe-auth/LoginPage'
import { LoginInput } from '@omnea-app/login/loginFrontendClient'
import { LoginApiClient } from '@omnea-app/login/loginHttpClient'

const Login = () => {
  const { query } = useRouter()

  const [loginStep, setLoginStep] = useState<LoginSteps>('Initial')
  const [signupError, setSignupError] = useState<null | string | string[]>(null)
  const { mutateAsync: login } = useLogin()

  const { callbackUrl, error } = query
  const redirectUrl = isArray(callbackUrl) ? callbackUrl[0] : callbackUrl

  const url = redirectUrl ?? ''

  const emailFromCallback = redirectUrl ? new URL(redirectUrl).searchParams.get('email') : null

  useEffect(() => {
    if (!isNil(error)) {
      setSignupError(error)
    }
  }, [error])

  const handleInitialLoginRequest = async ({ email, useEmailFlow = false }: { email: string; useEmailFlow?: boolean }) => {
    const { data: loginData, error: loginError } = await login({ input: { email, useEmailFlow, callbackUrl: url } })

    if (loginError) {
      setSignupError('Default')
      return
    }

    // SSO flow
    if (loginData?.shouldUseSSO) {
      await signIn('workos', undefined, { organization: loginData.workosOrgId || '' })
      return
    }

    // Email login flow
    setLoginStep('MagicLink')
  }

  return (
    <LoginPage
      emailFromUrl={emailFromCallback}
      loginStep={loginStep}
      onInitialLoginRequest={handleInitialLoginRequest}
      onUserInputChange={() => setSignupError(null)}
      setLoginStep={setLoginStep}
      signupError={signupError}
    />
  )
}

export default Login

const useLogin = () => {
  return useMutation({
    mutationFn: async ({ input }: LoginInput) => {
      const loginClient = new LoginApiClient({})
      return await loginClient.POST('/', {
        body: { input },
      })
    },
  })
}
